

import { atom , useRecoilValue, useSetRecoilState, useResetRecoilState} from "recoil";


const wareHouseAtomList = atom({key:'warehouse_atom', default:{   warehouse:[]}});

const warehouseEditAtom = atom({key:'warehouse_atom_edit', default:{}});




export  const SetWareHouseList = () => useSetRecoilState(wareHouseAtomList);
export  const GetWareHouseList = () => useRecoilValue(wareHouseAtomList);

export  const SetWareHouseEdit = () => useSetRecoilState(warehouseEditAtom);
export  const GetWareHouseEdit = () => useRecoilValue(warehouseEditAtom);
export  const ResetWareHouseEdit = () => useResetRecoilState(warehouseEditAtom);








